import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/States";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/giris");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setSession(data);
        window.history.replaceState(null, "", "/panel");
        navigate("/panel", { replace: true });
      } catch {
        toast.error("Google ile giriş başarısız oldu");
        navigate("/giris", { replace: true });
      }
    })();
  }, [location.hash, navigate, setSession]);

  return <LoadingState label="Giriş yapılıyor..." />;
}
